import useDealsByTags from '@order/hooks/useDealsByTags'
import useOrderValues from '@order/hooks/values/useOrderValues'
import useFlowName from '@order/hooks/useFlowName'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { useMemo } from 'react'
import { RecommendUtils } from 'recommend/RecommendUtils'

const useDealRecommendations = () => {
  const flowName = useFlowName()
  const deals = useDealsByTags({
    hidden: true,
    filterCards: true,
    requiredTags: [flowName],
  })

  const values = useOrderValues({})

  const config = useRemoteConfig()

  const dealsAvatar = useMemo(
    () => deals.byTags.avatar || [],
    [deals.byTags.avatar]
  )

  const recommendations = useMemo(() => {
    return RecommendUtils.groupDeals(dealsAvatar, {
      config,
      values: values.values,
      refraction: values.refraction,
      flowName,
    })
  }, [dealsAvatar, values, config, flowName])

  return {
    recommendations,
    rows: RecommendUtils.toDeals(recommendations, deals.all),
    all: dealsAvatar,
  }
}

export default useDealRecommendations
